import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from '../../../../../../../../components/items-table/create-column-definition-builder';
import { ReadOnlyCurrencyColumn } from './read-only-currency-column';

import messages from '../../messages';

const productCostColumnId = 'edit-product-cost-column';

const ProductCost = ({ value }) => <ReadOnlyCurrencyColumn currencyValue={value} />;

ProductCost.propTypes = {
  value: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
};

const productCostColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.productCost} />,
  accessor: productCostColumnId,
  cell: ProductCost,
  width: 1.5,
});

export { productCostColumnId, productCostColumnDefinition };
